export function DebugPantalla() {
  const vars = {
    VITE_AZURE_CLIENT_ID: import.meta.env.VITE_AZURE_CLIENT_ID ?? '(vacío)',
    VITE_AZURE_TENANT_ID: import.meta.env.VITE_AZURE_TENANT_ID ?? '(vacío)',
    VITE_AZURE_API_SCOPE: import.meta.env.VITE_AZURE_API_SCOPE ?? '(vacío)',
    VITE_AUTH_DEV_MODE: import.meta.env.VITE_AUTH_DEV_MODE ?? '(vacío)',
    VITE_API_URL: import.meta.env.VITE_API_URL ?? '(vacío)',
    MODE: import.meta.env.MODE,
    DEV: String(import.meta.env.DEV),
    PROD: String(import.meta.env.PROD),
  };

  return (
    <div className="p-6 space-y-2">
      <h1 className="text-lg font-bold">Variables de entorno (diagnóstico)</h1>
      <div className="border rounded-lg overflow-hidden">
        {Object.entries(vars).map(([k, v]) => (
          <div key={k} className="flex border-b last:border-0 px-3 py-2 text-sm">
            <span className="font-mono font-semibold w-56 shrink-0">{k}</span>
            <span className="font-mono text-muted-foreground truncate">{v}</span>
          </div>
        ))}
      </div>
    </div>
  );
}
